import React,{useContext,useEffect, useState, useRef, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from "primereact/checkbox";
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import UtilContext from '../../components/UtilContext';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';
import { confirmDialog } from 'primereact/confirmdialog';
import { LocaleContext } from '../../components/LocaleContext';

const GDPR_ACCESS_VALUES = new Set([
    'access training-invitation',
    'access users',
    'access company settings',
]);

function rowHasGdpr(row) {
    return GDPR_ACCESS_VALUES.has(row.view?.value);
}

/** Permission rows: labelKey is a locale key; view/add/edit/delete are sent to the API unchanged. */
const ROLE_PERMISSION_ROWS = [
        {labelKey: 'RoleAdd.PermissionsRow.priority',view:{name:'permissions',value:'access priorities'},add:{name:'permissions',value:'add priorities'},edit:{name:'permissions',value:'edit priorities'},delete:{name:'permissions',value:'delete priorities'}},
        {labelKey: 'RoleAdd.PermissionsRow.priority_setup',view:{name:'permissions',value:'access priorities-setup'},add:{name:'permissions',value:'add priorities-setup'},edit:{name:'permissions',value:'edit priorities-setup'},delete:{name:'permissions',value:'delete priorities-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.otk_section1',view:{name:'permissions',value:'access otk-section1'},add:{name:'permissions',value:'add otk-section1'},edit:{name:'permissions',value:'edit otk-section1'},delete:{name:'permissions',value:'delete otk-section1'}},
        {labelKey: 'RoleAdd.PermissionsRow.otk_section2',view:{name:'permissions',value:'access otk-section2'},add:{name:'permissions',value:'add otk-section2'},edit:{name:'permissions',value:'edit otk-section2'},delete:{name:'permissions',value:'delete otk-section2'}},
        {labelKey: 'RoleAdd.PermissionsRow.otk_section3',view:{name:'permissions',value:'access otk-section3'},add:{name:'permissions',value:'add otk-section3'},edit:{name:'permissions',value:'edit otk-section3'},delete:{name:'permissions',value:'delete otk-section3'}},
        {labelKey: 'RoleAdd.PermissionsRow.otk_documentation',view:{name:'permissions',value:'access otk-documentation'},add:{name:'permissions',value:'add otk-documentation'},edit:{name:'permissions',value:'edit otk-documentation'},delete:{name:'permissions',value:'delete otk-documentation'}},
        {labelKey: 'RoleAdd.PermissionsRow.otk_company',view:{name:'permissions',value:'access otk-company'},add:{name:'permissions',value:'add otk-company'},edit:{name:'permissions',value:'edit otk-company'},delete:{name:'permissions',value:'delete otk-company'}},
        {labelKey: 'RoleAdd.PermissionsRow.otk_statistics',view:{name:'permissions',value:'access otk-statistics'},add:{name:'permissions',value:'add otk-statistics'},edit:{name:'permissions',value:'edit otk-statistics'},delete:{name:'permissions',value:'delete otk-statistics'}},
        {labelKey: 'RoleAdd.PermissionsRow.otk_setup',view:{name:'permissions',value:'access otk-setup'},add:{name:'permissions',value:'add otk-setup'},edit:{name:'permissions',value:'edit otk-setup'},delete:{name:'permissions',value:'delete otk-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.painting',view:{name:'permissions',value:'access painting'},add:{name:'permissions',value:'add painting'},edit:{name:'permissions',value:'edit painting'},delete:{name:'permissions',value:'delete painting'}},
        {labelKey: 'RoleAdd.PermissionsRow.painting_setup',view:{name:'permissions',value:'access painting-setup'},add:{name:'permissions',value:'add painting-setup'},edit:{name:'permissions',value:'edit painting-setup'},delete:{name:'permissions',value:'delete painting-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.calibration',view:{name:'permissions',value:'access calibration'},add:{name:'permissions',value:'add calibration'},edit:{name:'permissions',value:'edit calibration'},delete:{name:'permissions',value:'delete calibration'}},
        {labelKey: 'RoleAdd.PermissionsRow.calibration_company',view:{name:'permissions',value:'access calibration-company'},add:{name:'permissions',value:'add calibration-company'},edit:{name:'permissions',value:'edit calibration-company'},delete:{name:'permissions',value:'delete calibration-company'}},
        {labelKey: 'RoleAdd.PermissionsRow.calibration_setup',view:{name:'permissions',value:'access calibration-setup'},add:{name:'permissions',value:'add calibration-setup'},edit:{name:'permissions',value:'edit calibration-setup'},delete:{name:'permissions',value:'delete calibration-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.checklists',view:{name:'permissions',value:'access checklists'},add:{name:'permissions',value:'add checklists'},edit:{name:'permissions',value:'edit checklists'},delete:{name:'permissions',value:'delete checklists'}},
        {labelKey: 'RoleAdd.PermissionsRow.checklists_complete_list',view:{name:'permissions',value:'access checklists-complete-list'},add:{name:'permissions',value:'add checklists-complete-list'},edit:{name:'permissions',value:'edit checklists-complete-list'},delete:{name:'permissions',value:'delete checklists-complete-list'}},
        {labelKey: 'RoleAdd.PermissionsRow.checklists_setup',view:{name:'permissions',value:'access checklists-setup'},add:{name:'permissions',value:'add checklists-setup'},edit:{name:'permissions',value:'edit checklists-setup'},delete:{name:'permissions',value:'delete checklists-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.training',view:{name:'permissions',value:'access training'},add:{name:'permissions',value:'add training'},edit:{name:'permissions',value:'edit training'},delete:{name:'permissions',value:'delete training'}},
        {labelKey: 'RoleAdd.PermissionsRow.training_company',view:{name:'permissions',value:'access training-company'},add:{name:'permissions',value:'add training-company'},edit:{name:'permissions',value:'edit training-company'},delete:{name:'permissions',value:'delete training-company'}},
        {labelKey: 'RoleAdd.PermissionsRow.training_invitation',view:{name:'permissions',value:'access training-invitation'},add:{name:'permissions',value:'add training-invitation'},edit:{name:'permissions',value:'edit training-invitation'},delete:{name:'permissions',value:'delete training-invitation'}},
        {labelKey: 'RoleAdd.PermissionsRow.training_setup',view:{name:'permissions',value:'access training-setup'},add:{name:'permissions',value:'add training-setup'},edit:{name:'permissions',value:'edit training-setup'},delete:{name:'permissions',value:'delete training-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.maintenance',view:{name:'permissions',value:'access maintenance'},add:{name:'permissions',value:'add maintenance'},edit:{name:'permissions',value:'edit maintenance'},delete:{name:'permissions',value:'delete maintenance'}},
        {labelKey: 'RoleAdd.PermissionsRow.maintenance_company',view:{name:'permissions',value:'access maintenance-company'},add:{name:'permissions',value:'add maintenance-company'},edit:{name:'permissions',value:'edit maintenance-company'},delete:{name:'permissions',value:'delete maintenance-company'}},
        {labelKey: 'RoleAdd.PermissionsRow.maintenance_setup',view:{name:'permissions',value:'access maintenance-setup'},add:{name:'permissions',value:'add maintenance-setup'},edit:{name:'permissions',value:'edit maintenance-setup'},delete:{name:'permissions',value:'delete maintenance-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.service_task',view:{name:'permissions',value:'access service_task'},add:{name:'permissions',value:'add service_task'},edit:{name:'permissions',value:'edit service_task'},delete:{name:'permissions',value:'delete service_task'}},
        {labelKey: 'RoleAdd.PermissionsRow.service_task_complete_list',view:{name:'permissions',value:'access service_task-complete-list'},add:{name:'permissions',value:'add service_task-complete-list'},edit:{name:'permissions',value:'edit service_task-complete-list'},delete:{name:'permissions',value:'delete service_task-complete-list'}},
        {labelKey: 'RoleAdd.PermissionsRow.service_task_setup',view:{name:'permissions',value:'access service_task-setup'},add:{name:'permissions',value:'add service_task-setup'},edit:{name:'permissions',value:'edit service_task-setup'},delete:{name:'permissions',value:'delete service_task-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.customer_management',view:{name:'permissions',value:'access customer_management'},add:{name:'permissions',value:'add customer_management'},edit:{name:'permissions',value:'edit customer_management'},delete:{name:'permissions',value:'delete customer_management'}},
        {labelKey: 'RoleAdd.PermissionsRow.customer_management_complete_list',view:{name:'permissions',value:'access customer_management-complete-list'},add:{name:'permissions',value:'add customer_management-complete-list'},edit:{name:'permissions',value:'edit customer_management-complete-list'},delete:{name:'permissions',value:'delete customer_management-complete-list'}},
        {labelKey: 'RoleAdd.PermissionsRow.customer_management_setup',view:{name:'permissions',value:'access customer_management-setup'},add:{name:'permissions',value:'add customer_management-setup'},edit:{name:'permissions',value:'edit customer_management-setup'},delete:{name:'permissions',value:'delete customer_management-setup'}},
        {labelKey: 'RoleAdd.PermissionsRow.settings_general',view:{name:'permissions',value:'access settings'},add:{name:'permissions',value:'add settings'},edit:{name:'permissions',value:'edit settings'},delete:{name:'permissions',value:'delete settings'}},
        {labelKey: 'RoleAdd.PermissionsRow.settings_users',view:{name:'permissions',value:'access users'},add:{name:'permissions',value:'add users'},edit:{name:'permissions',value:'edit users'},delete:{name:'permissions',value:'delete users'}},
        {labelKey: 'RoleAdd.PermissionsRow.settings_company',view:{name:'permissions',value:'access company settings'},add:{name:'permissions',value:'add company settings'},edit:{name:'permissions',value:'edit company settings'}},
    ];

export default function RoleAdd({role,type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText}= useContext(UtilContext);
    const { t } = useContext(LocaleContext);

    const permissions = ROLE_PERMISSION_ROWS;

    const gdprMessageForRow = (row) => t('RoleAdd.GdprConfirm').replace('{{module}}', t(row.labelKey));

    const [formRole,setFormRole] = useState(role);
    const [roleType, setRoleType] = useState(type);

    const [scrollIcons,setScrollIcons] = useState(true);
    const [closeTab,setCloseTab] = useState(false);

    const submitRef = useRef(null);
    const componentRef = useRef(null);

    useReactToPrint({
        onBeforeGetContent: () => { if(componentRef.current) componentRef.current.style.display = "block"; },
        onAfterPrint: () => { if(componentRef.current) componentRef.current.style.display = "none"; },
        content: () => componentRef.current,
    });

    useEffect(() => {
        if(roleType==="edit") setScrollIcons(false);
    },[roleType]);

    const formik = useFormik({
        initialValues: formRole==null ? { id:'', permissions:[], name:'', description:'' } : {
            id: formRole.id,
            name: formRole.name,
            description: formRole.description ?? '',
            permissions: (formRole.permissions || []).map((permission) => permission.name)
        },
        enableReinitialize:true,
        validate: () => ({}),
        onSubmit: values => {
            const formData = new FormData();
            // Pozn.: toto posiela pole ako "a,b,c" – ak chceš 100% čisté pole na BE,
            // môžeš posielať JSON.stringify(values.permissions) a na BE spraviť json_decode().
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }

            setDialogText(t('Common.Saving'));
            setVisible(true);

            if(roleType==="add"){
                postRequest('/api/roles', formData,true)
                .then(() => getRequest("/api/roles"))
                .then((response) => {
                    dispatch({type:'load_roles',newRoles:response.data});
                    if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                    if(response.data.length-1>=0) formik.setValues(response.data[response.data.length-1]);
                    setRoleType("edit");
                    setVisible(false);
                    toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                }).catch(() => {
                    setVisible(false);
                    alert(t('Common.Toast.ActionFailedDetail'));
                });
            } else {
                postRequest(`/api/roles/update/${formik.values.id}`, formData,true)
                .then(() => getRequest("/api/roles"))
                .then((response) => {
                    dispatch({type:'load_roles',newRoles:response.data});
                    if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                    formik.setValues(values);
                    setVisible(false);
                    toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                }).catch(() => {
                    setVisible(false);
                    alert(t('Common.Toast.ActionFailedDetail'));
                });
            }
        },
    });

    function addNewRole(){
        dispatch({type:'create_new_tab',name: t('RoleList.Tab.New'), translationKey: 'RoleList.Tab.New', legacyLabel: t('RoleList.Tab.New'),page:'RoleAdd',props:{role: null,type:'add'},mask:'gset012'})
    }

    function copyRole(){
        dispatch({type:'create_new_tab',name: t('RoleList.Tab.New'), translationKey: 'RoleList.Tab.New', legacyLabel: t('RoleList.Tab.New'),page:'RoleAdd',props:{role: formik.values,type:'copy'},mask:'gset012'})
    }

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(state.roles, formik.values.id, setFormRole),
        [state.roles, formik.values.id]
    );

    // ✅ zjednotené centrovanie (odstránené paddingLeft hacky)
    const headerCenter = (text) => (
        <div className="w-full flex justify-center whitespace-nowrap">{text}</div>
    );

    const checkboxWrap = (node) => (
        <div className="w-full flex justify-center items-center">{node}</div>
    );

    // -----------------------------
    // Povolenie Nastaviť štandardnú masku – len toto nad tabuľkou s Označ/odznač
    const STANDARD_MASK_PERMISSION = 'set standard mask';
    const standardMaskSelected = formik.values.permissions.includes(STANDARD_MASK_PERMISSION);
    const toggleStandardMask = () => {
        const set = new Set(formik.values.permissions);
        if (standardMaskSelected) set.delete(STANDARD_MASK_PERMISSION);
        else set.add(STANDARD_MASK_PERMISSION);
        formik.setFieldValue('permissions', Array.from(set));
    };

    // Označ/odznač: riadok, stĺpec (s dependency pravidlami)
    // -----------------------------
    const PERM_KEYS = ["view","add","edit","delete"];
    const rowValues = (row) => PERM_KEYS.filter((k) => row[k]).map((k) => row[k].value);

    const applyCell = (set, row, key, checked) => {
        if (key === 'delete' && !row.delete) {
            return;
        }
        const add = (v) => set.add(v);
        const del = (v) => set.delete(v);

        if (checked) {
            if (key === "view") add(row.view.value);
            if (key === "add") { add(row.view.value); add(row.add.value); }
            if (key === "edit") { add(row.view.value); add(row.add.value); add(row.edit.value); }
            if (key === "delete") { add(row.view.value); add(row.add.value); add(row.edit.value); add(row.delete.value); }
        } else {
            if (key === "view") {
                rowValues(row).forEach(del); // keď zrušíš access, zruš všetko v riadku
            } else if (key === "add") {
                [row.add.value, row.edit.value, row.delete.value].forEach(del);
            } else if (key === "edit") {
                [row.edit.value, row.delete.value].forEach(del);
            } else if (key === "delete") {
                del(row.delete.value);
            }
        }
    };

    const setCell = (row, key, checked) => {
        if (key === 'delete' && !row.delete) {
            return;
        }
        if (checked && rowHasGdpr(row)) {
            confirmDialog({
                message: gdprMessageForRow(row),
                header: t('RoleAdd.GdprDialogHeader'),
                icon: 'pi pi-info-circle',
                acceptLabel: t('RoleAdd.GdprAcceptAware'),
                rejectLabel: t('RoleAdd.GdprCancel'),
                accept: () => {
                    const set = new Set(formik.values.permissions);
                    applyCell(set, row, key, true);
                    formik.setFieldValue("permissions", Array.from(set));
                },
            });
            return;
        }
        const set = new Set(formik.values.permissions);
        applyCell(set, row, key, checked);
        formik.setFieldValue("permissions", Array.from(set));
    };

    // --- RIADKY ---
    const rowAllSelected = (row) =>
        rowValues(row).every((v) => formik.values.permissions.includes(v));

    const setRowAll = (row, checked) => {
        if (checked && rowHasGdpr(row)) {
            confirmDialog({
                message: gdprMessageForRow(row),
                header: t('RoleAdd.GdprDialogHeader'),
                icon: 'pi pi-info-circle',
                acceptLabel: t('RoleAdd.GdprAcceptAware'),
                rejectLabel: t('RoleAdd.GdprCancel'),
                accept: () => {
                    const set = new Set(formik.values.permissions);
                    rowValues(row).forEach((v) => set.add(v));
                    formik.setFieldValue("permissions", Array.from(set));
                },
            });
            return;
        }
        const set = new Set(formik.values.permissions);
        const vals = rowValues(row);
        if (checked) vals.forEach((v) => set.add(v));
        else vals.forEach((v) => set.delete(v));
        formik.setFieldValue("permissions", Array.from(set));
    };

    // --- STĹPCE ---
    const colBaseValues = (key) => permissions.map((r) => r[key]?.value).filter((v) => v != null && v !== '');

    const colAllSelected = (key) => {
        const vals = colBaseValues(key);
        return vals.length > 0 && vals.every((v) => formik.values.permissions.includes(v));
    };

    const toggleColumn = (key) => {
        const selected = colAllSelected(key);
        const set = new Set(formik.values.permissions);
        permissions.forEach((row) => applyCell(set, row, key, !selected));
        formik.setFieldValue("permissions", Array.from(set));
    };

    const headerWithColToggle = (label, key) => (
        <div className="w-full flex flex-col items-center gap-1">
            <div className="whitespace-nowrap">{label}</div>
            <button
                type="button"
                onClick={() => toggleColumn(key)}
                className="text-xs underline opacity-70 hover:opacity-100"
            >
                {colAllSelected(key) ? t('RoleAdd.PermissionsTable.Deselect') : t('RoleAdd.PermissionsTable.Select')}
            </button>
        </div>
    );

    // -----------------------------
    // Checkbox templaty
    // -----------------------------
    const rowToggleTemplate = (rowData) => checkboxWrap(
        <Checkbox
            checked={rowAllSelected(rowData)}
            onChange={(e) => setRowAll(rowData, e.checked)}
        />
    );

    const rowActionTemplate = (rowData) => (
        <div className="w-full flex justify-center items-center">
            <button
                type="button"
                onClick={() => setRowAll(rowData, !rowAllSelected(rowData))}
                className="text-xs underline opacity-70 hover:opacity-100"
            >
                {rowAllSelected(rowData) ? t('RoleAdd.PermissionsTable.Deselect') : t('RoleAdd.PermissionsTable.Select')}
            </button>
        </div>
    );


    const accessTemplate = (rowData) => checkboxWrap(
        <Checkbox
            checked={formik.values.permissions.includes(rowData.view.value)}
            onChange={(e) => setCell(rowData, "view", e.checked)}
            className="p-button-sm p-button-text"
        />
    );

    const addTemplate = (rowData) => checkboxWrap(
        <Checkbox
            checked={formik.values.permissions.includes(rowData.add.value)}
            onChange={(e) => setCell(rowData, "add", e.checked)}
            className="p-button-sm p-button-text"
        />
    );

    const editTemplate = (rowData) => checkboxWrap(
        <Checkbox
            checked={formik.values.permissions.includes(rowData.edit.value)}
            onChange={(e) => setCell(rowData, "edit", e.checked)}
            className="p-button-sm p-button-text"
        />
    );

    const deleteTemplate = (rowData) => {
        if (!rowData.delete) {
            return checkboxWrap(<span className="text-gray-500 text-xs">—</span>);
        }
        return checkboxWrap(
            <Checkbox
                checked={formik.values.permissions.includes(rowData.delete.value)}
                onChange={(e) => setCell(rowData, "delete", e.checked)}
                className="p-button-sm p-button-text"
            />
        );
    };

    // šírky stĺpcov – aby sa hlavičky a checkboxy nepohádali pri rôznych šírkach okna
    const rowCtlColStyle = { width: '7rem', maxWidth: '7rem', textAlign:'center' };
    const rowActionColStyle = { width: '6rem', maxWidth: '6rem', textAlign:'center' };
    const nameColStyle = { width: '28rem', maxWidth: '28rem' };
    const actionColStyle = { width: '7rem', maxWidth: '7rem', textAlign:'center' };
    const actionHeaderStyle = { textAlign:'center', backgroundColor: 'white', whiteSpace:'nowrap' };

    return (
        <>
        <style>{`
            /* zamedzí roztiahnutiu tabuľky na 100% šírky */
            .rolePermTable .p-datatable-table { width: max-content !important; }
            .rolePermTable .p-column-header-content { justify-content: center; }

            /* názov modulu je teraz 2. stĺpec (1. je "Riadok") */
            .rolePermTable .p-datatable-tbody > tr > td:nth-child(2) { white-space: nowrap; }
            .rolePermTable .p-datatable-thead > tr > th:nth-child(2) { width: 28rem; }

            @media (max-width: 1100px) {
              .rolePermTable .p-datatable-thead > tr > th:nth-child(2) { width: 18rem !important; }
              .rolePermTable .p-datatable-tbody > tr > td:nth-child(2) {
                white-space: normal;
                overflow-wrap: anywhere;
                word-break: break-word;
              }
            }
        `}</style>

        <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '>
                    <button type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button>
                </div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '>
                    <button type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button>
                </div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => addNewRole()}><AddIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => copyRole()}><CopyIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="opacity-25"><PrintIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => openFavoriteDialog(t('RoleList.Tab.New'),"RoleAdd")}><FavoriteIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("RoleAdd")}><PriceIcon/></button></div>
                <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
            </div>
            <form onSubmit={formik.handleSubmit}>
                <div className="relative flex flex-col justify-left overflow-x-auto h-[calc(100vh-177px)]">
                    <div className="gap-1 mb-2">
                        <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                            <h1 className="text-xl font-semibold text-left text-zinc-900">{t('RoleAdd.Title')}</h1>

                            {roleType==="edit" && (
                                <label className="block text-md font-semibold text-gray-800">{t('Common.RecordIdLabel')}: {formik.values.id}</label>
                            )}

                            <div className="md:w-auto mb-2">
                                <div className="mb-4">
                                    <label htmlFor="role-name" className="block text-md font-semibold text-gray-800">{t('RoleAdd.Label.Name')}</label>
                                    <input
                                        id="role-name"
                                        name='name'
                                        type="text"
                                        onChange={formik.handleChange}
                                        value={formik.values.name}
                                        className="block w-auto px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="role-description" className="block text-md font-semibold text-gray-800">{t('RoleAdd.Label.Description')}</label>
                                    <textarea
                                        id="role-description"
                                        name="description"
                                        rows={3}
                                        onChange={formik.handleChange}
                                        value={formik.values.description ?? ''}
                                        placeholder={t('RoleAdd.DescriptionPlaceholder')}
                                        className="block w-full max-w-xl px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40 resize-y"
                                    />
                                </div>

                                <div className='bg-gray-100 overflow-x-auto'>
                                    <div className="mb-3">
                                        <div className="mb-2">
                                            <button
                                                type="button"
                                                onClick={toggleStandardMask}
                                                className="px-3 py-1 text-sm font-semibold bg-white border rounded-md hover:bg-gray-50"
                                            >
                                                {standardMaskSelected ? t('RoleAdd.StandardMaskToggleAllOff') : t('RoleAdd.StandardMaskToggleAllOn')}
                                            </button>
                                        </div>
                                        <p className="text-sm font-semibold text-gray-800 mb-0.5">{t('RoleAdd.StandardMaskPermissionTitle')}</p>
                                        <p className="text-xs text-gray-600 mb-2">{t('RoleAdd.StandardMaskPermissionHelp')}</p>
                                        <div className="flex items-center gap-3 flex-wrap">
                                            <span className="flex items-center gap-1.5">
                                                <Checkbox checked={standardMaskSelected} onChange={toggleStandardMask} />
                                                <span className="text-sm">{standardMaskSelected ? t('RoleAdd.StandardMaskOn') : t('RoleAdd.StandardMaskOff')}</span>
                                            </span>
                                        </div>
                                    </div>

                                    <div className='inline-block'>
                                        <DataTable
                                            value={permissions}
                                            size="small"
                                            scrollable
                                            scrollHeight="calc(100vh - 470px)"
                                            responsiveLayout="scroll"
                                            className="rolePermTable"
                                            style={{ width: 'max-content' }}
                                            tableStyle={{ tableLayout: 'fixed', width: 'max-content' }}
                                        >
                                            <Column field="labelKey" header="" body={(rowData) => t(rowData.labelKey)} headerStyle={{backgroundColor: 'white'}} style={nameColStyle}></Column>
                                            <Column field="view" header={headerWithColToggle(t('RoleAdd.PermissionsTable.View'),"view")} body={accessTemplate} style={actionColStyle} headerStyle={actionHeaderStyle}></Column>
                                            <Column field="add" header={headerWithColToggle(t('RoleAdd.PermissionsTable.Add'),"add")} body={addTemplate} style={actionColStyle} headerStyle={actionHeaderStyle}></Column>
                                            <Column field="edit" header={headerWithColToggle(t('RoleAdd.PermissionsTable.Edit'),"edit")} body={editTemplate} style={actionColStyle} headerStyle={actionHeaderStyle}></Column>
                                            <Column field="delete" header={headerWithColToggle(t('RoleAdd.PermissionsTable.Delete'),"delete")} body={deleteTemplate} style={actionColStyle} headerStyle={actionHeaderStyle}></Column>
                                            <Column field="conditions" header={headerCenter(t('RoleAdd.PermissionsTable.Conditions'))} body={(rowData) => rowHasGdpr(rowData) ? <span className="text-sm text-amber-700">{t('RoleAdd.PermissionsTable.GdprTag')}</span> : null} style={{ ...actionColStyle, width: '6rem' }} headerStyle={actionHeaderStyle}></Column>
                                            <Column header="" body={rowActionTemplate} style={rowActionColStyle} headerStyle={actionHeaderStyle}></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="submit" ref={submitRef} className='hidden'></button>
                    </div>
                </div>
            </form>
        </div>
        </>
    )
}
